<template>
  <div class="episode">
    <router-link 
      :to="url"
    >
      <div v-if="trialEntitlement || episode.is_upcoming" 
        class="locked"
        @click.stop.prevent="toggleUpgradePlanDialog"
        >
        <lazy-image
          type="horizontal"
          :src="episode.img"
          :alt="episode.title"
          :title="episode.title"
        />
        <p v-if="episode.is_upcoming">
          {{ $t("available_on") }} <br />
          {{
            episode.publish_date.toHumanReadableDate(
                $t("navbar.currentLanguage")
            )
          }}
        </p>
      </div>
      <div v-else class="play">
        <lazy-image
          :src="episode.img"
          :alt="imgAlt === null ? episode.title : imgAlt"
          :title="episode.title"
        />
      </div>
      <span class="duration"
        >{{ episode.minutes ?? Math.floor(episode.duration / 60) }} min</span
      >
      <h3 class="title">
        {{ episode.episode }}.
        {{ episode.title !== undefined ? episode.title : episode["title_en"] }}
      </h3>
      <p class="description">{{ episode.overview ?? episode.description }}</p>
    </router-link>
  </div>
</template>

<script>
import LazyImage from "@/components/utils/LaziImage.vue";
import { mapState } from "pinia";
import { UserStore } from "@/stores/userStore";

export default {
  name: "EpisodeCard",
  components: { LazyImage },
  props: {
    playable: {
      type: Boolean,
      required: false,
      default: false,
    },
    episode: {
      type: Object,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
    imgAlt: {
      type: String,
      default: null,
    },
    imgTitle: {
      type: String,
      required: false,
    },
  },
  computed: {
    ...mapState(UserStore, [
      "isLoggedIn",
      "trialEntitlement"
    ]),
    url() {
      if(!this.isLoggedIn){
        return this.$t("routes.get_the_full_experience");
      }else if(this.trialEntitlement || this.episode.is_upcoming){
        return "";
      }


      return this.$t(this.playable ? "episode_route_play" : "episode_route", {
        slug: this.slug,
        season: this.episode.season,
        episode: this.episode.episode,
      });
    },
  },
  methods: {
    duration(secs) {
      return Math.round(secs / 60, 0);
    },
    toggleUpgradePlanDialog(){
      this.$emit('toggleUpgradePlanDialog');
    }
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/colors";
.episode {
  * {
    &:hover {
      text-decoration: none;
    }
  }
  .locked {
    position: relative;
    &:before {
      content: "";
      position: absolute;
      background: url("@/assets/img/episodes/locked.svg") no-repeat center
        center;
      background-size: contain;
      z-index: 99;
      width: 16%;
      height: 15%;
      top: 30%;
      left: 42%;
    }
    > p {
      color: $gray-3;
      width: 100%;
      position: absolute;
      bottom: 1em;
      text-align: center;
    }
  }
  .play {
    position: relative;
    &:before {
      content: "";
      position: absolute;
      background: url("@/assets/img/episodes/play-button.svg") no-repeat center
        center;
      background-size: cover;
      z-index: 99;
      width: 16%;
      height: 20%;
      top: 40%;
      left: 42%;
    }
  }
  img {
    border-radius: 16px;
    width: 100%;
  }
  h3 {
    color: #ffffff;
    font-size: 0.8em;
    margin: 1em 0.5em;
  }
  .description {
    color: #ffffff;
    font-size: 0.8em;
    margin: 0.5em 0.5em;
    font-weight: lighter;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .duration {
    color: $gray-3;
    float: right;
    font-size: 0.9em;
    padding: 1em 0 0 0;
    opacity: 0.8;
    font-weight: lighter;
  }
}
</style>
